import React from "react";
import {Snackbar} from '@mui/material'
import {Alert} from '@mui/material'

// const useStyles = makeStyles(theme => ({
//     root:{

//         top:theme.spacing(9)
//     }
// }))



export default function Notification(props){
    const {notify,setNotify} = props;
    // const classes = useStyles()

    const handlclose = (event,reason) =>{
        setNotify({
            ...notify,
            isOpen:false
        })
    }
    return(
        <Snackbar 
        open={notify.isOpen}
        autoHideDuration={3000}
        anchorOrigin={{vertical:'top',horizontal:'center'}}
        onClose = {handlclose}
        >   
            <Alert severity={notify.type}
             onClose = {handlclose}>
                {notify.messsage}
            </Alert>
        </Snackbar>
    )
}